import { all, takeEvery } from 'redux-saga/effects';

import * as normalizers from './normalizers';
import * as actions from './actions';
import * as LeanLink from '../../lib/LeanLinkService';

export function* fetchRequested(action) {
  yield LeanLink.apiCall(
    LeanLink.Mappings.customer({ id: action.id }),
    data => actions.fetchSuccess(normalizers.customer((data))),
    actions.fetchError,
  );
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.FETCH_REQUEST, fetchRequested),
  ]);
}
